module.exports = __webpack_public_path__ + "img/antes_despues_95.4cfe1fc0.png";